import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { addMembersAndInvitation, getMembers, updateMembers } from "../../../data/store/overviewSlice"
import { verifyEmailFormatUsingRegex } from "../../../data/utils"
import * as _ from 'lodash';
import AclComponentWrapper from "../AclComponentWrapper"
import { ACL_IDENTIFIERS } from "../../../data/configs/constants"
import { Row, Col, Typography, Input, Select, Checkbox, Button, Space } from 'antd';
import Notify, { notify } from "../Notify"
const { Title, Text } = Typography;
const { Option } = Select;

const AddMember = ({ defaultData = {}, onComplete = () => { }, onClose = () => { } }) => {
  const dispatch = useDispatch()
  const { tenantId } = useParams()
  const [member, setMember] = useState(defaultData?.email || "")
  const [role, setRole] = useState(defaultData?.role || "tenantManager")
  const [isLiveAgent, setIsLiveAgent] = useState(defaultData?.isLiveAgent || false);
  const [updatedKeys, setUpdatedKeys] = useState([]);
  const [memberError, setMemberError] = useState(false);
  const isUpdate = defaultData?._id || defaultData?.member || defaultData?.role || defaultData?.isLiveAgent;
  const modalLoading = useSelector((state) => state.pageDetails.modalLoading)
  const currentPageAcl = useSelector((state) => state.pageDetails?.currentPageAcl);

  const handleMemberAddition = (event) => {
    if (updatedKeys.indexOf('email') === -1) {
      setUpdatedKeys([...updatedKeys, 'email']);
    }
    setMember(event.target.value)
    setMemberError(!verifyEmailFormatUsingRegex(event.target.value));
  }

  const handleIsLiveAgentChanged = (event) => {
    if (updatedKeys.indexOf('isLiveAgent') === -1) {
      setUpdatedKeys([...updatedKeys, 'isLiveAgent']);
    }
    setIsLiveAgent(event.target.checked);
  }

  const handleRoleChange = (value) => {
    if (!updatedKeys.includes('role')) {
      setUpdatedKeys([...updatedKeys, 'role']);
    }
    setRole(value);
  };


  const showMessages = (msgArr = [], type = "success") => {
    msgArr.forEach(msg => {
      notify[type]({ message: msg })
    })
  }

  const addTeamMember = () => {
    dispatch(
      addMembersAndInvitation(
        {
          tenantId,
          invites: [
            {
              role,
              email: member,
              isLiveAgent
            }
          ]
        },
        (res) => {
          const invitations = res?.data?.invitations || [];
          const assignations = res?.data?.assignations || [];
          if (invitations?.success?.length > 0 || assignations?.success?.length > 0)
            showMessages([...invitations?.success, ...assignations?.success], "success");
          if (invitations?.warnings?.length > 0 || assignations?.warnings?.length > 0)
            showMessages([...invitations?.warnings, ...assignations?.warnings], "warning");
          if (invitations?.errors?.length > 0 || assignations?.errors?.length > 0)
            showMessages([...invitations?.errors, ...assignations?.errors], "error");
          dispatch(
            getMembers({
              tenantId,
            })
          )
          setMember("")
          onClose();
        }
      )
    )
  }

  const updateMember = () => {
    const updates = {
      email: member,
      role,
      isLiveAgent
    }
    dispatch(updateMembers(defaultData?._id, tenantId, {
      updates: _.pick(updates, updatedKeys)
    },
      (res) => {
        const invitations = res?.data?.invitations || [];
        const assignations = res?.data?.assignations || [];
        if (invitations?.success?.length > 0 || assignations?.success?.length > 0)
          showMessages([...invitations?.success, ...assignations?.success], "success");
        if (invitations?.warnings?.length > 0 || assignations?.warnings?.length > 0)
          showMessages([...invitations?.warnings, ...assignations?.warnings], "warning");
        if (invitations?.errors?.length > 0 || assignations?.errors?.length > 0)
          showMessages([...invitations?.errors, ...assignations?.errors], "error");
        dispatch(
          getMembers({
            tenantId,
          })
        )
        setMember("")
        onComplete();
      }
    ))
  }

  const handleSubmit = () => {
    if (isUpdate) {
      updateMember();
    } else {
      addTeamMember();
    }
  }

  return (
    <Row gutter={[16, 16]}>
      <Notify />
      <Col span={24}>
        <Title style={{ margin: 0 }} level={4}>Add a team member</Title>
      </Col>

      <Col span={24}>
        {memberError && <Text type="danger">Invalid Email Id</Text>}
        <Input
          placeholder="Enter email address"
          value={member}
          onChange={handleMemberAddition}
          size="large"
          disabled={isUpdate}
        />
      </Col>

      <Col span={24}>
        <Space style={{ display: 'flex', justifyContent: 'space-between' }} >
          <Select
            value={role}
            onChange={handleRoleChange}
            size="large"
            style={{ width: 400 }}
          >
            <Option value="tenantManager">Bot Manager</Option>
          </Select>

          <AclComponentWrapper
            payWallSize="icon"
            componentAcl={
              currentPageAcl?.[ACL_IDENTIFIERS.ADD_TEAM_MEMBERS]?.[ACL_IDENTIFIERS.LIVE_AGENT]
            }
          >
            <div style={{ marginLeft: 16 }}>
              <Text style={{ marginRight: 10 }} type="secondary">Live Agent</Text>
              <Checkbox
                defaultChecked={isLiveAgent}
                onChange={handleIsLiveAgentChanged}
              />
            </div>
          </AclComponentWrapper>
        </Space>
      </Col>

      <Col span={24}>
        <Button
          type="primary"
          size="large"
          onClick={handleSubmit}
          loading={modalLoading}
          disabled={!member || modalLoading || memberError}
          block
        >
          {isUpdate ? "Update Member" : "Assign role"}
        </Button>
      </Col>
    </Row>
  )
}

export default AddMember
